import { equals } from "@/helpers/ObjectsHelper";
import { SerializationHelper } from "@/helpers/SerializationHelper";

export class SalesCapacity {

    dayOfWeek: string;
    quantity: number;
    isUnlimited: boolean;
    delay: number;

    fromJSON(obj: any) {
        SerializationHelper.copyNonExcludedProperties(this, obj, []);
    }
    
    public equals(that: SalesCapacity): boolean {
        if (that == null) {
            return false;
        }

        return equals(this, that, (p: SalesCapacity) => p.dayOfWeek)
            && equals(this, that, (p: SalesCapacity) => p.quantity)
            && equals(this, that, (p: SalesCapacity) => p.isUnlimited)
            && equals(this, that, (p: SalesCapacity) => p.delay);
    }
}